import { useSelector } from '../redux/store';

export default function useFeaturePermission(featureName) {
    // Optional-chained to match the `permissions?.[featureName]` lookup below.
    // A partial store (every hand-rolled mock in tests/unit, and any future one)
    // otherwise throws here the moment a feature-gated component is rendered —
    // and 'hidden' is precisely what the real hook resolves to when the slice is
    // empty, so degrading is faithful rather than permissive.
    const permissions = useSelector((state) => state.permissions?.permissions);
    const level = permissions?.[featureName] || 'hidden';

    return {
        level,
        canView: level === 'view' || level === 'manage',
        canManage: level === 'manage',
        isHidden: level === 'hidden',
        isEnabled: level !== 'hidden',
    };
}
